var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_31794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.52045 30.4792C7.45795 30.4792 7.37462 30.4792 7.29129 30.4583C6.62462 30.3958 5.99962 30.0833 5.58295 29.5625C5.14545 29.0417 4.93712 28.375 4.99962 27.7083C5.47879 22.375 7.72879 17.2292 11.3121 13.25C13.7288 10.5833 16.6038 8.5 19.8955 7.08333C23.0621 5.70833 26.4163 5 29.8746 5C35.6871 5 41.2913 7.02083 45.7705 10.7292V7.52083C45.7705 6.125 46.8955 5 48.2913 5C49.6871 5 50.8121 6.125 50.8121 7.52083V15.9792C50.8121 18.3333 48.8955 20.25 46.5413 20.25H38.083C36.6871 20.25 35.5621 19.125 35.5621 17.7292C35.5621 16.3333 36.6871 15.2083 38.083 15.2083H43.2705C39.6246 11.9167 34.833 10.0625 29.9163 10.0417C19.5205 10.0625 10.958 17.875 10.0413 28.25C9.89545 29.5208 8.83295 30.4792 7.56212 30.4792H7.52045Z",
    fill: "#E76F51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9372 55.0001C24.1247 55.0001 18.5206 52.9792 14.0414 49.2709V52.4792C14.0414 53.8751 12.9164 55.0001 11.5206 55.0001C10.1247 55.0001 8.99973 53.8751 8.99973 52.4792V44.0209C8.99973 41.6667 10.9164 39.7501 13.2706 39.7501H21.7289C23.1247 39.7501 24.2497 40.8751 24.2497 42.2709C24.2497 43.6667 23.1247 44.7917 21.7289 44.7917H16.5414C19.7497 47.7084 23.8539 49.5209 28.2081 49.8959C28.7914 49.9376 29.3747 49.9792 29.9581 49.9792C40.1872 49.9792 48.8956 41.9792 49.7914 31.7709C49.9372 30.5001 50.9997 29.5417 52.2706 29.5417H52.3122C52.3747 29.5417 52.4581 29.5417 52.5414 29.5626C53.2081 29.6251 53.8331 29.9376 54.2497 30.4584C54.6872 30.9792 54.8956 31.6459 54.8331 32.3126C54.3539 37.6459 52.1039 42.7917 48.5206 46.7709C46.1039 49.4376 43.2289 51.5209 39.9581 52.9584C36.7497 54.2917 33.3956 55.0001 29.9372 55.0001Z",
    fill: "#E76F51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_31794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.8125,
    height: 50,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateIcon);
export default __webpack_public_path__ + "static/media/rotateIcon.a3792072f557fb36c251ab37070c5b37.svg";
export { ForwardRef as ReactComponent };